import React from "react";
import PropTypes from "prop-types";

function Banner(props) {
  return (
    <h2 className={`${props.className} wc-banner-text ${props.textClassName}`}>
      {props.text}
    </h2>
  );
}

Banner.defaultProps = {
  textClassName: "",
};

Banner.propTypes = {
  text: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  textClassName: PropTypes.string,
};

export default Banner;
